import { Link } from 'react-router-dom'
import { BRAND_NAME } from '../config/brand'
import { RISK_DISCLAIMER } from './AppFooter'

const PublicFooter = () => {
  return (
    <footer className="mt-6 flex flex-col items-center gap-2 text-sm text-white/80">
      <div className="flex items-center justify-center gap-4">
        <Link to="/terms" className="hover:text-white hover:underline">
          Terms
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy" className="hover:text-white hover:underline">
          Privacy
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/faq" className="hover:text-white hover:underline">
          FAQ
        </Link>
        <span aria-hidden="true">·</span>
        <Link to="/terms#disclaimers" className="hover:text-white hover:underline">
          Risk disclosure
        </Link>
      </div>
      <p className="text-xs text-white/70">
        {RISK_DISCLAIMER} © {new Date().getFullYear()} {BRAND_NAME}
      </p>
    </footer>
  )
}

export default PublicFooter
